import { create } from 'zustand';

interface NavigationStore {
  currentMenu: string;
  setCurrentMenu: (menuId: string) => void;
}

export const useNavigationStore = create<NavigationStore>((set) => ({
  currentMenu: 'home',
  setCurrentMenu: (menuId: string) => set({ currentMenu: menuId }),
}));
